
import React, { useEffect, useState } from 'react';
import { useCartStore } from "../../../hooks/cart";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import Cart from 'src/model/Cart';

const CartShippingAddress = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [onChangeValue, setOnChangeValue] = useState(false);
    const [{ CART_SHIPPING_ADDRESS_ID, SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE, SHIPPING_ADDRESS_LIST, CART_DATA }, { get_Mfr_code_validate_to_ship, shipping_address_list, get_cart_quote_number }, { shipping_address_id, SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE, SET_SELECTED_SHIPPING_ADDRESS }] = useCartStore();
    const [{ get_current_quote_cart }] = useQuoteDetailStore();
    const quoteList = get_current_quote_cart();
    const quoteNumber = get_cart_quote_number();

    const [isDisplayList, setIsDisplayList] = useState(false); // It is taken for show hide address DDL

    const getShippingAddressDisplayStatus = () => {
        if (quoteNumber) {
            return quoteList && Object.entries(quoteList).length > 0;
        } else {
            /** 9860 : Shipping Address dropdown will show everytime even if part is not available : Pankaj */
            return CART_DATA &&
                Object.entries(CART_DATA).length > 0 &&
                CART_DATA.length > 0;
        }
    };

    useEffect(() => {
        setIsDisplayList(getShippingAddressDisplayStatus())
    }, [CART_DATA, quoteList]);


    useEffect(() => {
        if (SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE) {
            get_Mfr_code_validate_to_ship(SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE);
        }
    }, [SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE]);

    useEffect(() => {
        if (quoteNumber && SHIPPING_ADDRESS_LIST && SHIPPING_ADDRESS_LIST?.length > 0 && CART_SHIPPING_ADDRESS_ID) {
            const countryCode = ((SHIPPING_ADDRESS_LIST).find(f => f.shipToAddressId === CART_SHIPPING_ADDRESS_ID)).countryCode;
            if (countryCode) {
                SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE(countryCode);
            }
        }
        SET_SELECTED_SHIPPING_ADDRESS(SHIPPING_ADDRESS_LIST, CART_SHIPPING_ADDRESS_ID)
    }, [SHIPPING_ADDRESS_LIST, CART_SHIPPING_ADDRESS_ID]);

    useEffect(() => {
        if (SHIPPING_ADDRESS_LIST && SHIPPING_ADDRESS_LIST.length > 0) {
            const index = SHIPPING_ADDRESS_LIST?.findIndex(v => v.isDefault);
            if (index >= 0) {
                const { shipToAddressId } = SHIPPING_ADDRESS_LIST[index];
                new Cart().setCartShippingAddress({
                    CART_SHIPPING_ADDRESS_ID: shipToAddressId
                });
            }
        }

    }, [SHIPPING_ADDRESS_LIST])

    useEffect(() => {
        async function fetchHere() {
            await shipping_address_list();
        }
        setTimeout(() => {
            fetchHere()
        }, 1200);
    }, []);

    const onChangeAddress = async (e, v) => {
        if (props.onChangeCallBack) {
            props.onChangeCallBack(v.countryCode);
            setOnChangeValue(v.shipToAddressId);
        }
        $('#shippingAddressDropDown').removeClass('open'); //  close dropdown after selection
        await shipping_address_id(v.shipToAddressId)
    }

    return (
        <>
            <div className="bs5 row mt-1">
                <div className="col-auto">
                    {quoteNumber ? <h1 aria-label="Quote Cart Summary" className='main-title'>Quote Cart Summary</h1> : <h1 aria-label="My Cart" className='main-title'>My Cart</h1>}
                </div>
                {isDisplayList &&
                    <div className="col-auto ms-auto align-self-end">
                        {CART_SHIPPING_ADDRESS_ID && 'Ship to Address'}
                        <div id={'shippingAddressDropDown'} className="dropdown selectbox">
                            <a className="bs5 form-control form-control-sm text-black dropdown-control w290 my-cart-address-select"
                                data-toggle="dropdown" aria-expanded="false" id="Customer"
                            >
                                <span>{SHIPPING_ADDRESS_LIST && SHIPPING_ADDRESS_LIST.length > 0 &&
                                    SHIPPING_ADDRESS_LIST.map((v) => (
                                        <React.Fragment
                                            key={v.shipToAddressId}>{(v.shipToAddressId === CART_SHIPPING_ADDRESS_ID || onChangeValue === v.shipToAddressId) &&
                                                <>
                                                    {v.name && v.name.trim() !== '' ? v.name + ', ' : ''} {v.addressLine && v.addressLine.trim() !== '' ? v.addressLine + ', ' : ''}
                                                    {v.postalCode && v.postalCode.trim() !== '' ? v.postalCode + ', ' : ''} {v.countrySubDivisionCode && v.countrySubDivisionCode.trim() !== '' ? v.countrySubDivisionCode + ', ' : ''}
                                                    {v.cityName && v.cityName.trim() !== '' ? v.cityName + ', ' : ''} {v.countryCode && v.countryCode.trim() !== '' ? v.countryCode : ''}
                                                </>
                                            }
                                        </React.Fragment>
                                    ))
                                }
                                    {!CART_SHIPPING_ADDRESS_ID &&
                                        <>Select Shipping Address</>
                                    }</span>
                            </a>
                            <ul className="dropdown-menu dropdown-menu-right" aria-label="dropdownMenuButton1">
                                {SHIPPING_ADDRESS_LIST && SHIPPING_ADDRESS_LIST.length > 0 &&
                                    SHIPPING_ADDRESS_LIST.map((v) => (
                                        <li key={v.shipToAddressId} value={v.shipToAddressId}
                                            onClick={async (e) => {
                                                await onChangeAddress(e, v);
                                            }}
                                        >
                                            <a href={void (0)} className={`dropdown-item text-black`}>
                                                <p style={{ fontWeight: (v.shipToAddressId === CART_SHIPPING_ADDRESS_ID || onChangeValue === v.shipToAddressId) && "bold" }} >
                                                    {v.name && v.name.trim() !== '' ? v.name + ', ' : ''} {v.addressLine && v.addressLine.trim() !== '' ? v.addressLine + ', ' : ''}
                                                    {v.postalCode && v.postalCode.trim() !== '' ? v.postalCode + ', ' : ''} {v.countrySubDivisionCode && v.countrySubDivisionCode.trim() !== '' ? v.countrySubDivisionCode + ', ' : ''}
                                                    {v.cityName && v.cityName.trim() !== '' ? v.cityName + ', ' : ''} {v.countryCode && v.countryCode.trim() !== '' ? v.countryCode : ''}
                                                </p>
                                            </a>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default CartShippingAddress;